import React from "react";
type propsType = {
  title: string;
};
const PageTitle = ({ title }: propsType) => {
  return (
    <h1 className="text-[25px] font-bold text-primary dark:text-white capitalize">
      {title}
    </h1>
  );
};

export default PageTitle;
